import { PageAbsolutePath } from '../../../consts/Common';

export const getStartQuotePath = (
  isDealer: boolean,
  useAlternateEligibility: boolean
): string => {
  if (isDealer) {
    return PageAbsolutePath.Insurance.DriveAway;
  }

  if (useAlternateEligibility) {
    return PageAbsolutePath.Insurance.AlternateEligibility;
  }

  return PageAbsolutePath.Insurance.EligibilityAncillaryPage;
};
